import { ChevronLeft, X } from "lucide-react";
import React from "react";
import { useNavigate } from "react-router";

interface Props {
    handleClose: () => void;
  }
  
  const FiltersForLists: React.FC<Props> = ({ handleClose }) => {
    const navigate = useNavigate();
  
  return (
    <div className="p-8">
      <div className="flex justify-between items-center mb-5">
        <h4 className="text-xl font-bold flex items-center -ms-2">
          <ChevronLeft
            size={22}
            className="me-3 cursor-pointer"
            onClick={() => navigate(-1)}
          />
          Filters for Lists
        </h4>
        <X onClick={handleClose} className="cursor-pointer" />
      </div>
    </div>
  );
};

export default FiltersForLists;
